import React from 'react'
import classes from './empty.module.css'
import classNames from 'classnames'

const Empty = ({ className, icon, text }) => {
    return (
        <div className={classNames(className, classes.empty)}>
            <img src={icon} alt="Empty" className={classes.emptyImage} />
            <h4 className={classes.emptyText}>{text}</h4>
        </div>
    )
}

export default Empty
